var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard__overview" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-6 mix__chart mix__chart--mfg" }, [
        _c(
          "div",
          { staticClass: "chart__wrapper" },
          [_c("ChartMixVendor", { staticClass: "chart__mix-sales" })],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-6 mix__chart mix__chart--tier" }, [
        _c(
          "div",
          { staticClass: "chart__wrapper" },
          [_c("ChartMixTier", { staticClass: "chart__mix-sales" })],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }